import { render, staticRenderFns } from "./AccidentIntakeHealthScreeningForm.vue?vue&type=template&id=31211174"
import script from "./AccidentIntakeHealthScreeningForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeHealthScreeningForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports